module.exports = __webpack_public_path__ + "7c817f925f7ddf034150da463d14fa97.svg";